import { server_ip } from "../config";

export async function studentFetchStudentMissions(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function adminFetchStudentMissions(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api/pstudentMissions/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function adminUpdateStudentMissions(token,id,data){
    try {
        const response= await fetch(`${server_ip}/api/pstudentMissions/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
        })
        return await response.json();
    }
    catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function teacherFetchStudentMissions(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api/pstudentMissions/teacher/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}


export async function studentParticipateMission(token,missionId){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/participate`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                missionId
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function studentConsent(token,id,isConsent){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/consent/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                isConsent
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function studentStartMission(token,id){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/start/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function studentSelectAvatar(token,id,avatar){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/avatar/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                avatar
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function studentUpdateMissionById(token,id,data){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function studentFinishMission(token,id,questions,progress){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/finish/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                questions,
                progress
            }),
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function studentStartQuestionnaireB(token,id){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/start/questionnaireB/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function studentStartQuestionnaireA(token,id){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/start/questionnaireA/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function studentFinishQuestionnaireB(token,id,questionnaires2){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/finish/questionnaire/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                questionnaires2
            }),
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function studentFinishQuestionnaireA(token,id,questionnaires1){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/student/finish/questionnaire/${id}`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                questionnaires1
            }),
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function teacherUpdateRemarks(token,id,remarks){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/teacher/remarks/${id}`,{
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                remarks
            }),
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function adminDeleteStudentMissions(token,id){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/${id}`,{
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function adminFetchQuestionnairesData(token,id){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/questionnaire/${id}`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function adminFetchStatisticalData(token,id){
    try{
        const response= await fetch(`${server_ip}/api/pstudentMissions/statistic/${id}`,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
        })
        return await response.json();
    }catch (error) {
        alert(JSON.stringify(error));
    }
}